import React from 'react';
import { QRCodeSVG } from 'qrcode.react';

/**
 * Branded QR code that links to the /jamboree page.
 * Black background with gold modules + small white frame so it
 * stays readable when baked into the dark flyer PNG.
 */
const FRAME_STYLE = {
  display: 'inline-flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: '0.4rem',
  background: '#fff',
  padding: '0.45rem 0.55rem 0.3rem',
  borderRadius: '10px',
  boxShadow: '0 4px 14px rgba(0, 0, 0, 0.35)',
};

const CAPTION_STYLE = {
  fontSize: '0.6rem',
  fontWeight: 800,
  letterSpacing: '1.2px',
  color: '#000',
  textTransform: 'uppercase',
};

const JamboreeQR = ({ size = 92, caption = 'SCAN TO REGISTER' }) => {
  const shareUrl =
    typeof window !== 'undefined'
      ? `${window.location.origin}/jamboree`
      : '/jamboree';

  return (
    <div style={FRAME_STYLE} data-testid="jamboree-qr">
      <QRCodeSVG
        value={shareUrl}
        size={size}
        level="M"
        bgColor="#ffffff"
        fgColor="#000000"
      />
      <span style={CAPTION_STYLE}>{caption}</span>
    </div>
  );
};

export default JamboreeQR;
